import React from "react";
import { SearchResultItem, SearchTag } from "./types";

interface ResultItemProps {
  item: SearchResultItem;
}

const getTagText = (tag: SearchTag) => tag.text || tag.value.split("_").pop() || tag.value;

const getVisibleTags = (tags: SearchTag[]) => {
  const kommunTags = tags.filter((tag) => tag.value.toLowerCase().includes("kommun"));
  if (kommunTags.length < 49) return tags.map(getTagText);

  return ["Alla kommuner", ...tags.filter((tag) => !kommunTags.includes(tag)).map(getTagText)];
};

export const ResultItem: React.FC<ResultItemProps> = ({ item }) => (
  <li className="list-block__result-item project-search-react__result-card">
    <div className="list-block__result-item-inner-content">
      <a href={item.url} dangerouslySetInnerHTML={{ __html: item.title }} />
      {item.ingress && <p>{item.ingress}</p>}
      {item.tags.length > 0 && (
        <p className="search-result__tags-metadata">
        <span className="sr-only">Kategorier</span>
        {getVisibleTags(item.tags).join(" \u2022 ")}
        </p>
      )}
    </div>
  </li>
);
